import { render } from "./ThePageContent.vue?vue&type=template&id=51a4f2ac&ts=true"
import script from "./ThePageContent.vue?vue&type=script&lang=ts"
export * from "./ThePageContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__